class ContentTypeMapper {
    constructor() {
      // Diccionario de extensiones y sus tipos MIME
      this.extensionToContentType = {
        // Tipos de archivo de texto
        "txt": "text/plain",
        "html": "text/html",
        "css": "text/css",
        "js": "text/javascript",
        "csv": "text/csv",
  
        // Tipos de archivo de imagen
        "jpeg": "image/jpeg",
        "jpg": "image/jpeg",
        "png": "image/png",
        "gif": "image/gif",
        "svg": "image/svg+xml",
        "webp": "image/webp",
  
        // Tipos de archivo de documento
        "pdf": "application/pdf",
        "doc": "application/msword",
        "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "xls": "application/vnd.ms-excel",
        "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "ppt": "application/vnd.ms-powerpoint",
        "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "rtf": "application/rtf",
  
        // Tipos de archivo de audio
        "mp3": "audio/mpeg",
        "wav": "audio/wav",
        "ogg": "audio/ogg",
  
        // Tipos de archivo de video
        "mp4": "video/mp4",
        "avi": "video/x-msvideo",
        "ogv": "video/ogg",
        "webm": "video/webm",
  
        // Tipos de archivo comprimido
        "zip": "application/zip",
        "gz": "application/gzip",
        "tar": "application/x-tar",
  
        // Tipos de archivo binario genérico
        "bin": "application/octet-stream",
  
        // Otros tipos comunes
        "json": "application/json",
        "xml": "application/xml",
        "x-www-form-urlencoded": "application/x-www-form-urlencoded"
      };
    }
  
    // Método para obtener el tipo MIME basado en la extensión
    getContentType(extension) {
      return this.extensionToContentType[extension.toLowerCase()] || "application/octet-stream";
    }
  }
  
  // Exportar la clase para usarla en otros archivos
  export default ContentTypeMapper;